<template>
    <AppModal :title="$t('paymentTable.newTariffModal.title')" ref="modal" size="lg">
        <div class="modal-body">
            <ul class="nav nav-tabs nav-tabs-solid nav-justified border-0">
                <li class="nav-item"><a href="#solid-justified-tab1" class="nav-link active" data-toggle="tab" @click="selectedPeriod = '1'">{{ $t('tariffs.period.1').toLowerCase() }}</a></li>
                <li class="nav-item"><a href="#solid-justified-tab2" class="nav-link" data-toggle="tab" @click="selectedPeriod = '3'">{{ $t('tariffs.period.3').toLowerCase() }}</a></li>
                <li class="nav-item"><a href="#solid-justified-tab3" class="nav-link" data-toggle="tab" @click="selectedPeriod = '6'">{{ $t('tariffs.period.6').toLowerCase() }}</a></li>
                <li class="nav-item"><a href="#solid-justified-tab4" class="nav-link" data-toggle="tab" @click="selectedPeriod = '12'">{{ $t('tariffs.period.12').toLowerCase() }}</a></li>
            </ul>

            <div class="row">
                <div class="col-lg-4" v-for="tariff in tariffsByMonth[selectedPeriod]" :key="tariff.id">
                    <TariffPlanCard
                        :tariff="tariff"
                        :base-tariff="tariffsByMonth['1'] ? tariffsByMonth['1'].find(t => t.name === tariff.name) : null"
                        :selected-period="selectedPeriod"
                        :most-popular-tariff="tariff.name === 'Start'"
                    />
                </div>
            </div>
        </div>
    </AppModal>
</template>
<script>
import AppModal from '../../../../../components/new/modal/AppModal.vue';
import TariffPlanCard from '../cards/TariffPlanCard.vue';
import { httpClient } from '../../../../../services/HttpClient';

export default {
    name: "NewTariffModal",
    components: {
        AppModal,
        TariffPlanCard
    },
    data() {
        return {
            selectedPeriod: '1',
            tariffsByMonth: {}
        }
    },
    methods: {
        show() {
            this.$refs.modal.show();
            this.fetchTariffs();
        },
        fetchTariffs() {
            httpClient.get(`/projects/${this.$route.params.projectUuid}/tariffs`, {
                limit: 100
            }).then((response) => {
                this.tariffsByMonth = response.data.data.reduce((acc, tariff) => {
                    if (!acc[tariff.months]) {
                        acc[tariff.months] = [];
                    }
                    acc[tariff.months].push(tariff);
                    return acc;
                }, {});
            })
        }
    }
}
</script>